import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BarChart2, TrendingUp, DollarSign, Warehouse, AlertTriangle } from 'lucide-react';
import { Card } from 'components/common/Card';

const reports = [
  { path: '/reports/sales', icon: BarChart2, title: 'Daily sales', desc: 'Net sales and units sold per day.' },
  { path: '/reports/profitability', icon: TrendingUp, title: 'Item profitability', desc: 'Sales, cost of goods and margin for every item.' },
  { path: '/reports/cost-changes', icon: DollarSign, title: 'Cost changes', desc: 'Every supplier cost change, old vs new.' },
  { path: '/reports/inventory-variance', icon: Warehouse, title: 'Inventory counts', desc: 'Physical counts compared with what the system expected.' },
  { path: '/reports/profit-leaks', icon: AlertTriangle, title: 'Profit leaks', desc: 'Every leak Pellvr found, with dollar impact and status.' },
];

export default function ReportsPage() {
  const navigate = useNavigate();
  return (
    <div className="space-y-5">
      <div className="flex items-center gap-2">
        <BarChart2 size={20} className="text-gray-600" />
        <h1 className="text-xl font-bold text-gray-900">Reports</h1>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {reports.map(r => {
          const Icon = r.icon;
          return (
            <Card key={r.path} className="cursor-pointer hover:border-blue-300 hover:shadow-md transition-all" onClick={() => navigate(r.path)}>
              <div className="flex items-start gap-4">
                <div className="p-2 bg-blue-50 rounded-lg"><Icon size={20} className="text-blue-600" /></div>
                <div>
                  <h3 className="text-sm font-semibold text-gray-900">{r.title}</h3>
                  <p className="text-xs text-gray-500 mt-1">{r.desc}</p>
                </div>
              </div>
            </Card>
          );
        })}
      </div>
    </div>
  );
}

